import api from "./axios";
import {
  RoamingApiStruct,
  RoamingCountriesByZoneStruct,
  RoamingCountryStruct,
  RoamingZoneStruct,
} from "@/struct/RoaminStruct";

export default class RoamingService {
  GetCountriesByZone = (
    zone_uuid = "" as string
  ): Promise<RoamingCountriesByZoneStruct> => {
    return api
      .post<RoamingApiStruct<RoamingCountriesByZoneStruct>>(
        "/api/public/roaming/countries-by-zone",
        { zone_uuid }
      )
      .then((res) => {
        if (res.data.status) return res.data.data;
        else throw res.data;
      })
      .catch((err) => {
        throw err;
      });
  };

  GetCountries = (
    search = "" as string,
    isPopular = false
  ): Promise<RoamingCountryStruct[]> => {
    return api
      .get<RoamingApiStruct<RoamingCountryStruct[]>>(
        "/api/public/roaming/get-countries",
        {
          params: {
            name: search,
            ...(isPopular && { is_popular: isPopular }),
          },
        }
      )
      .then((res) => {
        if (res.data.status) return res.data.data;
        else throw res.data;
      })
      .catch((err) => {
        throw err;
      });
  };

  GetZoneByUuid = (uuid = "" as string): Promise<RoamingZoneStruct> => {
    return api
      .post<RoamingApiStruct<RoamingZoneStruct>>(
        "/api/public/roaming/get-zone-by",
        { uuid }
      )
      .then((res) => {
        if (res.data.status) return res.data.data;
        else throw res.data;
      })
      .catch((err) => {
        throw err;
      });
  };
}
